import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TextField, Box, Button, AppBar, Modal, Tooltip, Container, FormControl, Toolbar, Typography, Paper } from '@mui/material';
import { Navigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const EditDepartment = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success');
  const [departmentName, setDepartmentName] = useState('');
  const [loadingBarProgress, setLoadingBarProgress] = useState('');
  const { deptId } = useParams();
  let navigate = useNavigate();
  const handleUpdate = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem('token');
      const response = await fetch(`${apiUrl}/Department/Id?DeptId=${deptId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify({
          departmentName: departmentName,
        }),
      });

      const data = await response.json();
      setLoadingBarProgress(100);

      const message = (data && (data.msg || data.message)) || 'Department has been updated successfully.';
      const status = (data && data.status && data.status.toString().toLowerCase()) || '';
      const lowerMsg = (message || '').toString().toLowerCase();
      const errorKeywords = ['already exist', 'already exists', 'failed', 'error', 'unable', 'cannot'];
      const messageHasError = status.includes('failed') || errorKeywords.some(k => lowerMsg.includes(k));

      setModalType(messageHasError ? 'error' : 'success');
      setModalMessage(message);
      setModalOpen(true);
    } catch (error) {
      console.error('API request error:', error);
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const handleCancel = () => {
    navigate(-1)
  };

  useEffect(() => {
    const fetchDepartmentData = async () => {
      try {
        setLoadingBarProgress(30);
        const token = sessionStorage.getItem('token');
        const apiUrl = process.env.REACT_APP_BASE_URL;
        const response = await fetch(
          `${apiUrl}/Department/DepartmentName`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: token,
            },
            body: JSON.stringify({}),
          }
        );

        if (response.ok) {
          const responseData = await response.json();
          const department = responseData.find((dept) => dept.deptId === parseInt(deptId));
          if (department) {
            setDepartmentName(department.departmentName);
          } else {
            console.error('Department not found for the given ID');
            // alert('Department not found');
            setSnackbarMessage('Department not found');
            setOpenSnackbar(true);
            setSnackbarSeverity("error");
          }
          setLoadingBarProgress(100);
        } else {
          console.error('Failed to fetch department data');
          // alert('Failed to fetch department data');
          setSnackbarMessage('Failed to fetch department data');
            setOpenSnackbar(true);
            setSnackbarSeverity("error");
          setLoadingBarProgress(0);
        }
      } catch (error) {
        console.error('API request error:', error);
        // alert('An error occurred. Please try again later.');
        setSnackbarMessage('An error occurred. Please try again later.');
            setOpenSnackbar(true);
            setSnackbarSeverity("error");
      }
    };

    fetchDepartmentData(); // Fetch department data when the component mounts
  }, [deptId]);

  return (
    <Container mt={4}>
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Add Department
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} sx={{ padding: 2, width: '100%', margin: 'auto', marginTop: 1 }}>
        <div>
          <TextField
            label="Department Name"
            variant="outlined"
            fullWidth
            value={departmentName}
            onChange={(e) => setDepartmentName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!departmentName && "Enter Department Name"} arrow>
            <span><Button
              variant="contained"
              color="primary"
              onClick={handleUpdate}
              sx={{ mr: 2 }}
              disabled={!departmentName}
            >
              UPDATE
            </Button></span></Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      </Paper>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: modalType === 'error' ? '#8B0000' : '#0B1F40', padding: '12px 16px' }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'error' ? 'Error ❌' : 'Department Updated ✅'}
            </Typography>
          </Box>

          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage || (modalType === 'error' ? 'An error occurred.' : 'Department has been updated successfully.')}
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType !== 'error') navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default EditDepartment;
